import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {DialogAnchorTemplateContent} from "./dialogAnchorTemplateContent";

@customElement("eop-inline-modal-dialog-button")
export class EopInlineModalDialogButton extends DialogAnchorTemplateContent {

    @property({attribute: "style"})
    private buttonStyle: string;
    @property({attribute: "size"})
    private buttonSize: string;
    @property({attribute: "disabled-button", type: Boolean})
    private disabledButton: boolean = false;
    @property()
    protected label: string;

    public render(): TemplateResult {
        return html`
            <button
                    class="uni-button ${this.buttonStyle} ${this.buttonSize}"
                    @click=${this.openDialog}
                    @keydown=${this.openDialog}
                    ?disabled=${this.disabledButton}
            >
                ${this.label}
            </button>
        `;
    }
}